import React from 'react'
import Videos from '../Videos';
import { useHistory } from 'react-router-dom'

const DBDA_SA = React.memo(() => {

    const history = useHistory();

    const nextRoute = () => {
        history.push('/question5')
    }

    const title = "SA-Spatial Ability";
    const url = "https://careers4me.in/videos/Spatial_Ability.mp4";

    return (
        <Videos title={title} url={url} onPress={nextRoute} />
    )
});

export default DBDA_SA